import { configureStore } from '@reduxjs/toolkit'
import generalReducer from './generalSlice';
import gameReducer from './gameSlice';
import editorReducer from './editorSlice';
import mesesageReducer from './messageSlice';

const store = configureStore({
  reducer: {
    general: generalReducer,
    game: gameReducer,
    editor: editorReducer,
    message: mesesageReducer,
  }
})

export type RootState = ReturnType<typeof store.getState>;
export default store;